import { connect } from 'react-redux'
import {fetchUser, handleSignOut} from '../../../store/user/duck'
import {
        analyticsSubmissions,
        analyticsClients
        } from '../../../store/analytics/duck'
import {
  getFilterParams,
  clearPhase
 } from '../../../store/dashboard/duck'
import AdminClientForm from './component'
const AnalyticsClients = connect(
  // Map state to props
  (state) => ({
    user: state.user.users,
    isSubmitting: state.user.isSubmitting,
    filterParams: state.dashboard.filterParams,
    dashSubmissionsData: state.analytics.dashSubmissionsData,
    rxError: state.user.error,
    phase: state.user.phase,
    dashclientPhase: state.analytics.dashclientPhase,
    clientAnalyticsPhase: state.analytics.clientAnalyticsPhase,
    clientAnalyticsData: state.analytics.clientAnalyticsData
  }),
  // Map actions to props
  {
    fetchUser,
    handleSignOut,
    getFilterParams,
    analyticsSubmissions,
    analyticsClients
  }
)(AdminClientForm)
export default AnalyticsClients
